import PropTypes from "prop-types";
import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  TablePagination,
  Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";
import SessaoAuth from "../../Hooks/SessaoAuth";

const URL_SERVICE = "/relat/listar";

const RelatoriosTabela = ({ relatorios, setRelatorios, setLoading, setAvisoErro, setAvisoSucesso }) => {

  const { sessao, setSessao } = SessaoAuth();
  const setRowsPerPage = (newRowsPerPage) => {
    setSessao((prev) => ({ ...prev, rowsPerPage: newRowsPerPage }));
  }

  const [orderBy, setOrderBy] = useState("codigo");
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const navigate = useNavigate();

  // Função para ordenar os dados
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...relatorios].sort((a, b) => {
    const valA = a[orderBy] ?? "";
    const valB = b[orderBy] ?? "";

    if (valA < valB) return order === "asc" ? -1 : 1;
    if (valA > valB) return order === "asc" ? 1 : -1;
    return 0;
  });

  const paginatedData = sortedData.slice(
    page * sessao.rowsPerPage,
    page * sessao.rowsPerPage + sessao.rowsPerPage
  );

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

    // Função para editar pedido
  const handleImprimir = (e, request) => {
    e?.preventDefault();
    navigate(`/relatorios/${request}`);
  };

  return (
    <Box>
      <Paper sx={{ mt: 2 }} elevation={4}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell 
                sx={{ width: 90, textAlign: "center" }}
                sortDirection={orderBy === "id" ? order : false}>
                  <TableSortLabel
                    active={orderBy === "id"}
                    direction={orderBy === "id" ? order : "id"}
                    onClick={() => handleSort("id")}
                  >
                    Código
                  </TableSortLabel>
                </TableCell>
                <TableCell sortDirection={orderBy === "descricao" ? order : false}>
                  <TableSortLabel
                    active={orderBy === "descricao"}
                    direction={orderBy === "descricao" ? order : "asc"}
                    onClick={() => handleSort("descricao")}
                  >
                    Descrição
                  </TableSortLabel>
                </TableCell>
                <TableCell>{/* Ícones */}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((reg, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ width: 90, textAlign: "center" }}>{reg.id}</TableCell>
                  <TableCell>{reg.descricao}</TableCell>
                  <TableCell>
                    <Box
                      sx={{ display: "flex", gap: 1, justifyContent: "end" }}
                    >
                      <IconButton
                        aria-label="editar"
                        onClick={(event) => handleImprimir(event, reg.id)}
                      >
                        <PrintIcon style={{ color: "#1a3865" }} />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={relatorios.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={sessao.rowsPerPage}
          labelRowsPerPage="Linhas por página"
          rowsPerPageOptions={[5, 10, 25]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          justifyContent="bottom"
          sx={{
            "& .MuiTablePagination-toolbar": {
              alignItems: "center",
            },
            "& p": {
              marginBottom: 0, // Remove a margem inferior do <p>
            },
          }}
        />
      </Paper>
    </Box >
  );
};

RelatoriosTabela.propTypes = {
  relatorios: PropTypes.array.isRequired,
  setRelatorios: PropTypes.func,
  setLoading: PropTypes.func,
  setAvisoErro: PropTypes.func,
  setAvisoSucesso: PropTypes.func,
};

export default RelatoriosTabela;
